module.exports = __webpack_public_path__ + "img/组 127(3).55fe9d0e.png";